import React, { createContext, useContext, type ReactNode } from 'react';
import { EMPTY_FACILITY_PROFILE, type FacilityProfile } from '../domain/facility';

type EditorFacilityContextValue = {
  facility: FacilityProfile;
  mediaSourcesVersion: number;
};

const defaultContextValue: EditorFacilityContextValue = {
  facility: EMPTY_FACILITY_PROFILE,
  mediaSourcesVersion: 0,
};

const EditorFacilityContext =
  createContext<EditorFacilityContextValue>(defaultContextValue);

type EditorFacilityProviderProps = {
  facility: FacilityProfile;
  mediaSourcesVersion?: number;
  children: ReactNode;
};

export function EditorFacilityProvider({
  facility,
  mediaSourcesVersion = 0,
  children,
}: EditorFacilityProviderProps) {
  return (
    <EditorFacilityContext.Provider value={{ facility, mediaSourcesVersion }}>
      {children}
    </EditorFacilityContext.Provider>
  );
}

export function useEditorFacility(): FacilityProfile {
  return useContext(EditorFacilityContext).facility;
}

export function useEditorMediaSourcesVersion(): number {
  return useContext(EditorFacilityContext).mediaSourcesVersion;
}
